export default __webpack_public_path__ + "assets/Lato-Black.57dee8aface5572f91010e02036d2085.ttf";